export const articlesByCategory: Record<string, Array<{
  id: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
}>> = {
  entertainment: [
    {
      id: 'article-2',
      title: '亚洲流媒体大战：2026年各大平台内容策略解析',
      excerpt: 'Netflix、Disney+、爱奇艺、Viu等流媒体平台在亚洲市场的竞争日趋白热化。本土化内容策略成为制胜关键，韩剧、日漫、华语剧集的投资规模不断刷新纪录...',
      category: '娱乐',
      categorySlug: 'entertainment',
      author: '李思雨',
      date: '2026-08-09',
      readTime: '6分钟',
      image: 'https://readdy.ai/api/search-image?query=Modern%20home%20entertainment%20setup%20with%20large%20screen%20displaying%20colorful%20streaming%20interface%2C%20warm%20cozy%20living%20room%2C%20soft%20ambient%20lighting%2C%20minimalist%20decor%2C%20cinematic%20atmosphere&width=1200&height=800&seq=article-streaming&orientation=landscape',
    },
    {
      id: 'article-6',
      title: '亚洲移动游戏市场报告：超休闲游戏仍占主导',
      excerpt: '2026年上半年亚洲移动游戏市场规模突破800亿美元。超休闲游戏凭借低门槛、高留存的特点持续吸引大量用户，而中重度游戏则在ARPU值上保持领先...',
      category: '娱乐',
      categorySlug: 'entertainment',
      author: '赵子龙',
      date: '2026-08-05',
      readTime: '6分钟',
      image: 'https://readdy.ai/api/search-image?query=Colorful%20mobile%20gaming%20setup%20with%20smartphone%20displaying%20casual%20game%2C%20warm%20ambient%20lighting%2C%20minimalist%20desk%20with%20gaming%20accessories%2C%20modern%20aesthetic&width=1200&height=800&seq=article-gaming&orientation=landscape',
    },
    {
      id: 'article-8',
      title: '日本动漫产业数字化转型：AI动画制作新时代',
      excerpt: '日本动漫产业正在经历一场深刻的数字化转型。AI辅助动画制作工具的普及，正在改变传统的手绘制作流程，大幅提升制作效率...',
      category: '娱乐',
      categorySlug: 'entertainment',
      author: 'Sarah Tanaka',
      date: '2026-08-11',
      readTime: '5分钟',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20production%20studio%20with%20digital%20drawing%20tablets%20and%20colorful%20character%20designs%20on%20screens%2C%20warm%20creative%20workspace%2C%20soft%20lighting%2C%20artistic%20atmosphere&width=1200&height=800&seq=article-anime&orientation=landscape',
    },
    {
      id: 'article-ent-1',
      title: 'K-Pop数字化转型：虚拟偶像与AI音乐创作',
      excerpt: '韩国流行音乐产业正积极拥抱AI和虚拟现实技术。从AI辅助作曲到虚拟偶像团体，K-Pop正在重新定义21世纪的音乐娱乐体验...',
      category: '娱乐',
      categorySlug: 'entertainment',
      author: '朴智恩',
      date: '2026-08-04',
      readTime: '7分钟',
      image: 'https://readdy.ai/api/search-image?query=Futuristic%20K-pop%20concert%20stage%20with%20holographic%20performers%20and%20colorful%20neon%20lights%2C%20warm%20purple%20and%20pink%20atmosphere%2C%20modern%20entertainment%20technology%2C%20dynamic%20composition&width=1200&height=800&seq=article-kpop&orientation=landscape',
    },
    {
      id: 'article-ent-2',
      title: '亚洲电影市场复苏：2026年暑期档票房分析',
      excerpt: '随着疫情的全面结束，亚洲电影市场在2026年迎来强劲复苏。中国、印度、日本三大市场的暑期档票房均创下历史新高...',
      category: '娱乐',
      categorySlug: 'entertainment',
      author: '陈小明',
      date: '2026-08-03',
      readTime: '8分钟',
      image: 'https://readdy.ai/api/search-image?query=Modern%20cinema%20theater%20interior%20with%20large%20screen%20and%20comfortable%20red%20seats%2C%20warm%20ambient%20lighting%2C%20empty%20luxurious%20auditorium%2C%20cinematic%20atmosphere&width=1200&height=800&seq=article-cinema&orientation=landscape',
    },
  ],
  news: [
    {
      id: 'article-7',
      title: '新加坡智慧城市建设经验：亚洲城市的数字化范本',
      excerpt: '新加坡作为全球智慧城市的标杆，其数字化建设经验对亚洲其他城市具有重要借鉴意义。本文深入剖析新加坡智慧国计划的成功要素...',
      category: '资讯',
      categorySlug: 'news',
      author: '林俊杰',
      date: '2026-08-11',
      readTime: '7分钟',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Singapore%20skyline%20with%20Marina%20Bay%20Sands%20and%20futuristic%20Supertree%20Grove%2C%20warm%20golden%20hour%20light%2C%20clean%20architectural%20photography%2C%20smart%20city%20concept&width=1200&height=800&seq=article-singapore&orientation=landscape',
    },
    {
      id: 'article-1',
      title: '2026年亚洲数字经济发展趋势：AI驱动的全新时代',
      excerpt: '随着人工智能技术的飞速发展，亚洲各国纷纷加速数字化转型。从新加坡智慧国家到中国数字经济的蓬勃发展，亚洲正在成为全球数字创新的核心引擎...',
      category: '资讯',
      categorySlug: 'news',
      author: '张明远',
      date: '2026-08-10',
      readTime: '8分钟',
      image: 'https://readdy.ai/api/search-image?query=Futuristic%20Asian%20cityscape%20with%20digital%20data%20flows%20and%20AI%20visualizations%2C%20warm%20golden%20sunset%20light%2C%20modern%20skyscrapers%2C%20clean%20minimalist%20aesthetic%2C%20professional%20editorial%20style&width=1200&height=800&seq=article-digital-economy&orientation=landscape',
    },
    {
      id: 'article-news-1',
      title: 'RCEP生效两周年：亚洲区域经济一体化成效显著',
      excerpt: '区域全面经济伙伴关系协定实施两年来，亚洲区域内贸易额增长超过15%。成员国之间的关税减让和贸易便利化措施持续释放红利...',
      category: '资讯',
      categorySlug: 'news',
      author: '王建国',
      date: '2026-08-09',
      readTime: '6分钟',
      image: 'https://readdy.ai/api/search-image?query=Modern%20international%20trade%20conference%20room%20with%20Asian%20flags%20and%20digital%20screens%20showing%20trade%20data%2C%20warm%20professional%20lighting%2C%20clean%20corporate%20aesthetic&width=1200&height=800&seq=article-rcep&orientation=landscape',
    },
    {
      id: 'article-news-2',
      title: '亚洲清洁能源转型：太阳能与风能投资创新高',
      excerpt: '2026年上半年亚洲清洁能源投资总额突破5000亿美元。中国、印度和日本领跑太阳能和风能装机容量增长，东南亚各国也加速淘汰化石能源...',
      category: '资讯',
      categorySlug: 'news',
      author: '刘芳菲',
      date: '2026-08-08',
      readTime: '5分钟',
      image: 'https://readdy.ai/api/search-image?query=Vast%20solar%20panel%20farm%20in%20desert%20landscape%20with%20wind%20turbines%20in%20background%2C%20warm%20sunset%20light%2C%20clean%20energy%20theme%2C%20modern%20sustainable%20technology&width=1200&height=800&seq=article-energy&orientation=landscape',
    },
  ],
  shopping: [
    {
      id: 'article-3',
      title: '跨境电商新蓝海：东南亚市场2026年掘金指南',
      excerpt: 'Shopee、Lazada、TikTok Shop三大平台在东南亚持续扩张。RCEP协议红利下，中国品牌出海东南亚迎来了前所未有的机遇...',
      category: '购物',
      categorySlug: 'shopping',
      author: '王浩然',
      date: '2026-08-08',
      readTime: '10分钟',
      image: 'https://readdy.ai/api/search-image?query=Modern%20ecommerce%20logistics%20warehouse%20with%20packages%20and%20digital%20screens%20showing%20shipping%20routes%20across%20Southeast%20Asia%2C%20warm%20industrial%20lighting%2C%20clean%20organized%20space&width=1200&height=800&seq=article-ecommerce&orientation=landscape',
    },
    {
      id: 'article-9',
      title: '印度电商Flipkart和Meesho崛起：下一个十亿用户市场',
      excerpt: '印度电商市场正在经历爆炸式增长。Flipkart和Meesho两大本土电商平台通过差异化的策略，正在争夺印度这个拥有十亿潜在用户的巨大市场...',
      category: '购物',
      categorySlug: 'shopping',
      author: 'Amit Patel',
      date: '2026-08-10',
      readTime: '8分钟',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Indian%20ecommerce%20fulfillment%20center%20with%20packages%20and%20workers%2C%20warm%20lighting%2C%20organized%20industrial%20space%2C%20colorful%20branding%20elements&width=1200&height=800&seq=article-india-ecom&orientation=landscape',
    },
    {
      id: 'article-shop-1',
      title: '直播电商2.0时代：AI虚拟主播改变购物体验',
      excerpt: '从真人主播到AI数字人，直播电商正在进入2.0时代。淘宝直播、抖音电商等平台纷纷推出AI虚拟主播功能，实现7x24小时不间断直播带货...',
      category: '购物',
      categorySlug: 'shopping',
      author: '周晓琳',
      date: '2026-08-07',
      readTime: '6分钟',
      image: 'https://readdy.ai/api/search-image?query=Modern%20livestream%20shopping%20studio%20with%20AI%20virtual%20host%20on%20large%20screen%20and%20products%20displayed%2C%20warm%20studio%20lighting%2C%20clean%20professional%20setup%2C%20ecommerce%20theme&width=1200&height=800&seq=article-livestream&orientation=landscape',
    },
  ],
  social: [
    {
      id: 'article-4',
      title: 'Web3社交网络崛起：去中心化如何改变亚洲社交格局',
      excerpt: 'Lens Protocol、Farcaster等去中心化社交协议正在亚洲获得大量用户。从内容创作经济到用户数据主权，Web3社交网络为亚洲用户带来了全新的数字社交体验...',
      category: '社交',
      categorySlug: 'social',
      author: '陈雅婷',
      date: '2026-08-07',
      readTime: '7分钟',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20decentralized%20network%20visualization%20with%20connected%20nodes%20and%20warm%20glowing%20links%2C%20modern%20digital%20art%20style%2C%20clean%20minimalist%20composition%2C%20soft%20gradient%20background&width=1200&height=800&seq=article-web3&orientation=landscape',
    },
    {
      id: 'article-10',
      title: '韩国社交媒体新趋势：KakaoTalk和Zepeto的元宇宙布局',
      excerpt: '韩国社交巨头Kakao正在将旗下KakaoTalk和元宇宙平台Zepeto深度整合，打造全新的社交元宇宙体验。这一战略布局引发整个亚洲社交行业的关注...',
      category: '社交',
      categorySlug: 'social',
      author: '金泰亨',
      date: '2026-08-09',
      readTime: '6分钟',
      image: 'https://readdy.ai/api/search-image?query=Colorful%20Korean%20digital%20avatar%20interface%20on%20smartphone%20screen%2C%20warm%20cafe%20setting%2C%20modern%20minimalist%20aesthetic%2C%20soft%20natural%20light%20through%20window&width=1200&height=800&seq=article-korea-social&orientation=landscape',
    },
  ],
  tech: [
    {
      id: 'article-1',
      title: '2026年亚洲数字经济发展趋势：AI驱动的全新时代',
      excerpt: '随着人工智能技术的飞速发展，亚洲各国纷纷加速数字化转型。从新加坡智慧国家到中国数字经济的蓬勃发展，亚洲正在成为全球数字创新的核心引擎...',
      category: '科技',
      categorySlug: 'tech',
      author: '张明远',
      date: '2026-08-10',
      readTime: '8分钟',
      image: 'https://readdy.ai/api/search-image?query=Futuristic%20Asian%20cityscape%20with%20digital%20data%20flows%20and%20AI%20visualizations%2C%20warm%20golden%20sunset%20light%2C%20modern%20skyscrapers%2C%20clean%20minimalist%20aesthetic%2C%20professional%20editorial%20style&width=1200&height=800&seq=article-digital-economy&orientation=landscape',
    },
    {
      id: 'article-7',
      title: '新加坡智慧城市建设经验：亚洲城市的数字化范本',
      excerpt: '新加坡作为全球智慧城市的标杆，其数字化建设经验对亚洲其他城市具有重要借鉴意义。本文深入剖析新加坡智慧国计划的成功要素...',
      category: '科技',
      categorySlug: 'tech',
      author: '林俊杰',
      date: '2026-08-11',
      readTime: '7分钟',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Singapore%20skyline%20with%20Marina%20Bay%20Sands%20and%20futuristic%20Supertree%20Grove%2C%20warm%20golden%20hour%20light%2C%20clean%20architectural%20photography%2C%20smart%20city%20concept&width=1200&height=800&seq=article-singapore&orientation=landscape',
    },
    {
      id: 'article-tech-1',
      title: '亚洲半导体产业链重构：日本和韩国的新机遇',
      excerpt: '全球芯片供应链正在经历深刻变革。日本和韩国作为亚洲半导体产业重镇，正在加大投资力度，争夺下一代芯片制造技术的主导权...',
      category: '科技',
      categorySlug: 'tech',
      author: '田中一郎',
      date: '2026-08-06',
      readTime: '9分钟',
      image: 'https://readdy.ai/api/search-image?query=Modern%20semiconductor%20fabrication%20facility%20cleanroom%20with%20silicon%20wafers%20and%20precision%20equipment%2C%20warm%20yellow%20cleanroom%20lighting%2C%20high-tech%20industrial%20aesthetic&width=1200&height=800&seq=article-semicon&orientation=landscape',
    },
    {
      id: 'article-tech-2',
      title: '亚洲量子计算竞赛：中国超导量子比特突破1000位',
      excerpt: '中国科学技术大学团队成功研制出超过1000个量子比特的超导量子计算机原型。这一里程碑标志着亚洲在量子计算领域的领先地位...',
      category: '科技',
      categorySlug: 'tech',
      author: '李明德',
      date: '2026-08-04',
      readTime: '7分钟',
      image: 'https://readdy.ai/api/search-image?query=Futuristic%20quantum%20computing%20laboratory%20with%20cryogenic%20cooling%20systems%20and%20laser%20optics%2C%20warm%20scientific%20lighting%2C%20clean%20modern%20research%20facility%20aesthetic&width=1200&height=800&seq=article-quantum&orientation=landscape',
    },
  ],
  lifestyle: [
    {
      id: 'article-5',
      title: '亚洲健康科技爆发：2026年最值得关注的医疗创新',
      excerpt: '从AI辅助诊断到远程医疗平台，亚洲健康科技领域正经历前所未有的创新浪潮。新加坡、日本、韩国和中国的初创企业在这个领域表现尤为突出...',
      category: '生活',
      categorySlug: 'lifestyle',
      author: '林小雨',
      date: '2026-08-06',
      readTime: '5分钟',
      image: 'https://readdy.ai/api/search-image?query=Modern%20medical%20technology%20lab%20with%20digital%20health%20monitoring%20devices%20and%20holographic%20displays%2C%20warm%20clean%20lighting%2C%20minimalist%20white%20interior%2C%20professional%20atmosphere&width=1200&height=800&seq=article-healthtech&orientation=landscape',
    },
    {
      id: 'article-life-1',
      title: '亚洲美食旅游地图：2026年必访的十大美食城市',
      excerpt: '从东京筑地市场到曼谷唐人街，从首尔广藏市场到新加坡小贩中心。本文为吃货们精选2026年亚洲最值得专程前往的十大美食城市...',
      category: '生活',
      categorySlug: 'lifestyle',
      author: '蔡依琳',
      date: '2026-08-05',
      readTime: '6分钟',
      image: 'https://readdy.ai/api/search-image?query=Colorful%20Asian%20street%20food%20market%20with%20various%20dishes%20and%20steam%20rising%2C%20warm%20evening%20light%20with%20lanterns%2C%20vibrant%20atmosphere%2C%20food%20photography%20style&width=1200&height=800&seq=article-food&orientation=landscape',
    },
    {
      id: 'article-life-2',
      title: '亚洲冥想与正念潮流：数字时代的心理健康革命',
      excerpt: '在快节奏的数字生活中，越来越多的亚洲年轻人开始关注心理健康。冥想App下载量在亚洲激增300%，正念练习正在成为一种全新的生活方式...',
      category: '生活',
      categorySlug: 'lifestyle',
      author: '张欣怡',
      date: '2026-08-03',
      readTime: '5分钟',
      image: 'https://readdy.ai/api/search-image?query=Serene%20modern%20meditation%20space%20with%20natural%20light%20and%20minimalist%20decor%2C%20warm%20wooden%20floor%2C%20indoor%20plants%2C%20peaceful%20atmosphere%2C%20wellness%20lifestyle%20photography&width=1200&height=800&seq=article-meditation&orientation=landscape',
    },
  ],
};

export const categoryMeta: Record<string, { name: string; description: string; keywords: string; icon: string; image: string }> = {
  entertainment: {
    name: '娱乐',
    description: '影视音乐、游戏电竞、综艺节目等泛娱乐内容。亚洲在线娱乐平台为您提供最新最全的亚洲娱乐资讯。',
    keywords: '亚洲在线娱乐平台,亚洲娱乐资讯,流媒体,游戏电竞,K-Pop,动漫',
    icon: 'ri-movie-2-line',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20entertainment%20stage%20with%20dynamic%20lighting%20effects%2C%20warm%20atmosphere%2C%20cinematic%20movie%20posters%20and%20gaming%20elements%20displayed%20artistically%2C%20soft%20ambient%20light%2C%20modern%20minimalist%20composition&width=1200&height=600&seq=cat-header-entertainment&orientation=landscape',
  },
  news: {
    name: '资讯',
    description: '亚洲热点新闻、财经动态、科技前沿资讯。亚洲在线资讯服务为您提供7x24小时亚洲要闻追踪。',
    keywords: '亚洲在线资讯服务,亚洲新闻,财经动态,科技前沿,亚洲热点',
    icon: 'ri-newspaper-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20newsroom%20with%20multiple%20screens%20displaying%20breaking%20news%2C%20warm%20lighting%2C%20clean%20minimalist%20desk%20setup%2C%20professional%20atmosphere&width=1200&height=600&seq=cat-header-news&orientation=landscape',
  },
  shopping: {
    name: '购物',
    description: '精选好物推荐、优惠折扣、购物攻略指南。亚洲在线购物平台为您发现亚洲最值得买的商品。',
    keywords: '亚洲在线购物,跨境电商,好物推荐,购物攻略,东南亚电商',
    icon: 'ri-shopping-bag-3-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20online%20shopping%20display%20with%20premium%20lifestyle%20products%20arranged%20on%20minimalist%20shelves%2C%20warm%20neutral%20tones%2C%20soft%20studio%20lighting%2C%20clean%20composition&width=1200&height=600&seq=cat-header-shopping&orientation=landscape',
  },
  social: {
    name: '社交',
    description: '社区互动、话题讨论、兴趣圈层交流平台。亚洲在线社交平台连接志同道合的亚洲用户。',
    keywords: '亚洲在线社交,社交平台,兴趣社区,Web3社交,元宇宙',
    icon: 'ri-group-line',
    image: 'https://readdy.ai/api/search-image?query=Diverse%20group%20of%20people%20connecting%20through%20digital%20devices%20in%20warm%20modern%20space%2C%20soft%20natural%20light%2C%20friendly%20atmosphere%2C%20minimalist%20interior&width=1200&height=600&seq=cat-header-social&orientation=landscape',
  },
  tech: {
    name: '科技',
    description: 'AI人工智能、数码产品、互联网创新技术。亚洲在线追踪亚洲最新科技动态和产业趋势。',
    keywords: 'AI人工智能,数码产品,互联网创新,半导体,量子计算,亚洲科技',
    icon: 'ri-cpu-line',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20technology%20lab%20with%20holographic%20displays%20and%20circuit%20boards%2C%20warm%20ambient%20lighting%20with%20subtle%20neon%20accents%2C%20minimalist%20design%2C%20clean%20modern%20aesthetic&width=1200&height=600&seq=cat-header-tech&orientation=landscape',
  },
  lifestyle: {
    name: '生活',
    description: '健康养生、美食旅游、家居生活品质指南。亚洲在线生活板块为您的美好生活提供灵感和建议。',
    keywords: '健康养生,美食旅游,家居生活,心理健康,亚洲生活方式',
    icon: 'ri-heart-pulse-line',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20modern%20lifestyle%20scene%20with%20healthy%20food%20and%20travel%20accessories%20on%20wooden%20table%2C%20soft%20natural%20window%20light%2C%20minimalist%20Scandinavian%20interior%2C%20peaceful%20atmosphere&width=1200&height=600&seq=cat-header-lifestyle&orientation=landscape',
  },
};